//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            telephone: this.$route.query.telephone || '',
            system: '',
        }
    },
    methods: {
        getSystem(){
            let u = navigator.userAgent;
            if(u.indexOf('Android') > -1 || u.indexOf('Linux') > -1){
                this.system = 'Android';
            }else if(u.indexOf('iPhone') > -1){
                this.system = 'iPhone';
            }else if(u.indexOf('Windows Phone') > -1){//winphone手机
                alert("winphone手机");
            }
        }
    },
    //生命周期之创建完成
    created: function() {
        this.getSystem();
        document.title = '注册';
    }
}



// WEBPACK FOOTER //
// ./src/views/explain/index.vue